<template>
  <div class="head-line" :class="{'border-bottom': showBorder}" @click="goDetail">
    <div class="img-wrap">
      <img v-if="content.coverPicture" :src="content.coverPicture" alt="中海头条">
      <img
        v-else
        alt="中海头条"
        src="https://coli688-qzq-service.oss-cn-shenzhen.aliyuncs.com/pc-images/headline-palceholder.png"
      />
    </div>
    <div class="content">
      <div class="title">{{ content.title }}</div>
      <div class="desc">{{headContent}}</div>
      <div class="time">{{ content.createdAt | timeFilter }}</div>
    </div>
  </div>
</template>
<script>
import { headLineUrl } from '@/api/config'
export default {
  props: {
    showBorder: {
      type: Boolean,
      default: true
    },
    content: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {

    }
  },
  computed: {
    headContent () {
      let word = this.content.content.match(/[\u4e00-\u9fa5]/g) && this.content.content.match(/[\u4e00-\u9fa5]/g).join("").replace("图片","").replace("图片","")
      return word;
    }
  },
  filters: {
    timeFilter (val) {
      if (!val) return
      const timeArr = val.substring(0, 10).split('-')
      let str =  `${timeArr[0]}年${timeArr[1]}月${timeArr[2]}日`
      return str
    }
  },
  methods: {
    goDetail () {
      window.scrollTo(0, 0)
      const url = headLineUrl + '1/' + this.content.id
      this.$router.push({ path: `/headLine/detail?headLineUrl=${encodeURI(url)}` })
    },
  }
}
</script>
<style lang="scss" scoped>
.head-line{
  display: flex;
  justify-content: flex-start;
  padding: 30px 0;
  cursor: pointer;
  .img-wrap{
    img{
      width: 232px;
      height: 153px;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-left: 25px;
    .title{
      @include font20(550, rgba(51, 51, 51, 1));
      font-family: PingFangSC-Medium;
      &:hover{
        color: rgba(189, 162, 108, 1);
      }
    }
    .desc{
      @include font14(400, #9399A5);
      margin-top: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical
    }
    .time{
      @include font14(400, #9399A5);
      margin-top: auto;
    }
  }
}
.border-bottom{
  border-bottom: 1px solid #E6E6E6;
}
</style>
